// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.RegisterVerify_auth-card-header__qKW48 {
    padding-bottom: 30px;
    border-radius: 20px 20px 0 0;
    text-align: center;
    font-size: 16px;
    color: var(--main-color);
}

.RegisterVerify_opt-input__W\\+urp {
    width: 55px !important;
    height: 37px !important;
    border: 2px solid transparent;
    outline: none;
    font-size: 20px;
    border-radius: 5px;
    /* background-color: #131D44; */
    background-color: #fff;
    color: grey;
    -webkit-user-select: none;
            user-select: none;
}
.RegisterVerify_opt-input__W\\+urp:focus {
    border-color: #FFF;
}
.RegisterVerify_verify-submit__RIyc7 {
    text-align: center;
    margin-top: 40px;
}
.RegisterVerify_error-message__3S4db {
    margin-top: 5px;
    display: block;
    font-size: 15px;
    color: red;
}
/* Screen Width 1281px to Higher Resolution Desktops
--------------------------------------------------------------------------- */
@media (min-width : 1281px){

}


/* Laptop and Desktops
---------------------------------------------------------------------------- */
@media (min-width: 1025px) and (max-width: 1280px){

}


/* Tablet and IPad (portrait)
----------------------------------------------------------------------------- */
@media (min-width: 768px) and (max-width: 1024px){

}


/* Tablet and IPad (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 768px) and (max-width: 1024px) and (orientation : landscape){
   .RegisterVerify_container-main__aT26x {
      padding: 70px 15px;
   }
}


/* Low Resolution Tablet and Mobile (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 481px) and (max-width: 767px) {
    .RegisterVerify_container-main__aT26x {
        padding: 70px 15px;
     }

     .RegisterVerify_auth-card__9HAz8 {
        width: 100%;
     }
     .RegisterVerify_opt-input__W\\+urp {
        width: 55px !important;
        height: 37px !important;
        font-size: 20px;
     }
}


/* Smartphones Mobiles (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 320px) and (max-width: 480px) {
   .RegisterVerify_container-main__aT26x {
      padding: 70px 15px;
   }
   .RegisterVerify_auth-card__9HAz8 {
      width: 100%;
   }
   .RegisterVerify_opt-input__W\\+urp {
    width: 40px !important;
    height: 30px !important;
    font-size: 16px;
   }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/RegisterVerify.module.css"],"names":[],"mappings":";AACA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;AACd;AACA;6EAC6E;AAC7E;;AAEA;;;AAGA;8EAC8E;AAC9E;;AAEA;;;AAGA;+EAC+E;AAC/E;;AAEA;;;AAGA;+EAC+E;AAC/E;GACG;MACG,kBAAkB;GACrB;AACH;;;AAGA;+EAC+E;AAC/E;IACI;QACI,kBAAkB;KACrB;;KAEA;QACG,WAAW;KACd;KACA;QACG,sBAAsB;QACtB,uBAAuB;QACvB,eAAe;KAClB;AACL;;;AAGA;+EAC+E;AAC/E;GACG;MACG,kBAAkB;GACrB;GACA;MACG,WAAW;GACd;GACA;IACC,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;GAChB;AACH","sourcesContent":["\n.auth-card-header {\n    padding-bottom: 30px;\n    border-radius: 20px 20px 0 0;\n    text-align: center;\n    font-size: 16px;\n    color: var(--main-color);\n}\n\n.opt-input {\n    width: 55px !important;\n    height: 37px !important;\n    border: 2px solid transparent;\n    outline: none;\n    font-size: 20px;\n    border-radius: 5px;\n    /* background-color: #131D44; */\n    background-color: #fff;\n    color: grey;\n    user-select: none;\n}\n.opt-input:focus {\n    border-color: #FFF;\n}\n.verify-submit {\n    text-align: center;\n    margin-top: 40px;\n}\n.error-message {\n    margin-top: 5px;\n    display: block;\n    font-size: 15px;\n    color: red;\n}\n/* Screen Width 1281px to Higher Resolution Desktops\n--------------------------------------------------------------------------- */\n@media (min-width : 1281px){\n\n}\n\n\n/* Laptop and Desktops\n---------------------------------------------------------------------------- */\n@media (min-width: 1025px) and (max-width: 1280px){\n\n}\n\n\n/* Tablet and IPad (portrait)\n----------------------------------------------------------------------------- */\n@media (min-width: 768px) and (max-width: 1024px){\n\n}\n\n\n/* Tablet and IPad (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 768px) and (max-width: 1024px) and (orientation : landscape){\n   .container-main {\n      padding: 70px 15px;\n   }\n}\n\n\n/* Low Resolution Tablet and Mobile (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 481px) and (max-width: 767px) {\n    .container-main {\n        padding: 70px 15px;\n     }\n\n     .auth-card {\n        width: 100%;\n     }\n     .opt-input {\n        width: 55px !important;\n        height: 37px !important;\n        font-size: 20px;\n     }\n}\n\n\n/* Smartphones Mobiles (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 320px) and (max-width: 480px) {\n   .container-main {\n      padding: 70px 15px;\n   }\n   .auth-card {\n      width: 100%;\n   }\n   .opt-input {\n    width: 40px !important;\n    height: 30px !important;\n    font-size: 16px;\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auth-card-header": `RegisterVerify_auth-card-header__qKW48`,
	"opt-input": `RegisterVerify_opt-input__W+urp`,
	"verify-submit": `RegisterVerify_verify-submit__RIyc7`,
	"error-message": `RegisterVerify_error-message__3S4db`,
	"container-main": `RegisterVerify_container-main__aT26x`,
	"auth-card": `RegisterVerify_auth-card__9HAz8`
};
export default ___CSS_LOADER_EXPORT___;
